import ApiService from "./ApiService";
 
export async function apiTicketDashboardData(params) {
    return ApiService.fetchData({
        url: 'operation/analytics?type=tickets',
        method: 'get',
        //params
    })
}
 
export async function apigetAlertsData(){
    return ApiService.fetchData({
        url:'operation/analytics?type=alerts',
        method:'get'
    })
   
}
 
export async function apiGetAnalyticsDashboard(){
    return ApiService.fetchData({
        url:'account/analytics',
        method:'get'
    })
   
}
 
// export async function apiCreateTicket(data) {
//     try {
//         const resp = await ApiService.fetchData({
//             url: 'operation/ticketing-modules',
//             method: 'post',
//             data,
//         })
//         return {
//             status: 'success',
//             data: resp,
//         }
//     } catch (errors) {
//         return {
//             status: 'failed',
//             message: errors?.response?.data || errors.toString(),
//         }
//     }
// }
 
// export async function apiGetVehicleDashboard(params) {
//     return ApiService.fetchData({
//         url: 'operation/vehicle-masters',
//         method: 'get',
//         params
//     })
// }
 
// export async function apigetSamrtFileredData(params) {
//     return ApiService.fetchData({
//         url: `operation/vehicle-masters-search/${params}`,
//         method: 'get',
//         // params
//     })
// }
 
// export async function apiGetSearchList(params) {
//     return ApiService.fetchData({
//         url: `operation/vehicle-meta-data/${params}`,
//         method: 'get'
//     })
// }
// export async function apiGetTicketStatus(params) {
//     return ApiService.fetchData({
//         url: `operation/ticketing-modules-comments-status/${params}`,
//         method: 'get'
 
//     })
// }
 
// export async function apiGetDealerLocaton(params) {
//     try {
 
//         const resp = await ApiService.fetchData({
//             url: `operation/dealers-masters/location/${params}`,
//             method: 'get',
//         })
//         return {
//             status: 'success',
//             data: resp,
//         }
//     } catch (errors) {
//         return {
//             status: 'failed',
//             data: errors?.response?.data || errors.toString(),
//         }
//     }
// }
 
// export async function apiGetServiceDealerLocaton(params) {
//     try {
 
//         const resp = await ApiService.fetchData({
//             url: `operation/dealers-masters/dealercodes`,
//             method: 'get',
//         })
//         return {
//             status: 'success',
//             data: resp,
//         }
//     } catch (errors) {
//         return {
//             status: 'failed',
//             data: errors?.response?.data || errors.toString(),
//         }
//     }
// }
 